/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratEnablerInfo,
    JsonStratEnablerInfoFromJSON,
    JsonStratEnablerInfoFromJSONTyped,
    JsonStratEnablerInfoToJSON,
} from './JsonStratEnablerInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStratEnablerInfo
 */
export interface ApiResultOfJsonStratEnablerInfo {
    /**
     * 
     * @type {JsonStratEnablerInfo}
     * @memberof ApiResultOfJsonStratEnablerInfo
     */
    data?: JsonStratEnablerInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratEnablerInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStratEnablerInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratEnablerInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratEnablerInfo
     */
    result?: ApiResultOfJsonStratEnablerInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStratEnablerInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStratEnablerInfoFromJSON(json: any): ApiResultOfJsonStratEnablerInfo {
    return ApiResultOfJsonStratEnablerInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonStratEnablerInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStratEnablerInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStratEnablerInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStratEnablerInfoToJSON(value?: ApiResultOfJsonStratEnablerInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStratEnablerInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

